import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from '../../../service/billing-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, KeyValues3, LocalService, Status, TriggeredEvent } from '../../../service/local.service';
import { ProductManagementService } from '../../../service/product-management.service';

@Component({
  selector: 'app-serial-numbers-mapping',
  templateUrl: './serial-numbers-mapping.component.html',
  styleUrls: ['./serial-numbers-mapping.component.scss']
})
export class SerialNumbersMappingComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["serial_num"]; isShowDummyHeight = false; maxBodyHeight = 0;
  isViewMode = false; productId = ''; billingId = ''; batchId: string = ''; intractionType = 1; qty = 0; isIntegerQty = false;
  serialNumbers: KeyValues3[]; selectedSerialNumber: string = null; selectedSerialNumbers: KeyValues3[] = [];
  txtSerialNumber = '';
  elementIds = {
    manual_ser_num: 'manual_ser_num'
  };

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private productManagementService: ProductManagementService, private activeModal: NgbActiveModal, private billingManagementService: BillingManagementService) { }

  ngOnInit(): void {
    let sQty = this.qty ? this.qty.toString() : '0';
    if (sQty.indexOf('.') > -1) {
      let sQtys = sQty.split('.');
      this.isIntegerQty = parseInt(sQtys[1]) == 0;
    } else {
      this.isIntegerQty = true;
    }
    if (!this.isViewMode && this.intractionType == 1)
      this.isViewMode = true;
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.billingManagementService.getSerialNumberMapInitialization(this.billingId, this.productId, this.batchId).subscribe(result => {
      this.selectedSerialNumbers = result.mapped;
      this.onValidateLoadedSerialNumbers(result.availableSerialNumbers);
    });
  }

  onLoadSerialNumbers() {
    this.serialNumbers = null;
    this.productManagementService.getAvailableSerialNumbers(this.productId).subscribe(result => {
      this.onValidateLoadedSerialNumbers(result);
    });
  }

  onValidateLoadedSerialNumbers(items: KeyValues3[]) {
    if (items.find(x => x.key == '-')) {
      items.find(x => x.key == '-').v1 = this.localService.languageContent.serial_num ? this.localService.languageContent.serial_num.create_dummy : '-';
      items.find(x => x.key == '-').v3 = "0";
    }
    this.selectedSerialNumbers.filter(x => x.key != '-').forEach(x => {
      items = items.filter(y => y.key != x.key);
    });
    this.serialNumbers = items;
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    let items = this.selectedSerialNumbers.map(x => x.key);
    this.billingManagementService.saveSerialNumbers(this.billingId, this.productId, items, this.batchId).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.activeModal.close({ event: TriggeredEvent.Ok, data: items });
      }
    });
  }

  showHideDummyHeight(isShow: boolean) {
    this.isShowDummyHeight = isShow;
  }

  onAddSerialNumber(isManual = false) {
    if (isManual) {
      if (this.txtSerialNumber) {
        this.productManagementService.isValidSerialNumber(this.productId, this.txtSerialNumber).subscribe(result => {
          if (result.status == Status.Success) {
            this.onAddSerialNumberFinal(result.id);
          } else {
            this.localService.showInformationByStatus(result.status, true);
            this.localService.onFocusNextInput(this.elementIds.manual_ser_num, FocusInputType.TextBox);
          }
        });
      } else {
        this.localService.showInformationByStatus(Status.DataRequired, true);
      }
    } else if (this.selectedSerialNumber && this.selectedSerialNumber != '') {
      this.onAddSerialNumberFinal();
    }
  }

  onAddSerialNumberFinal(key = '') {
    let serailNumberItem = key ? { key: key, v1: this.txtSerialNumber } as KeyValues3 : this.serialNumbers.find(x => x.key == this.selectedSerialNumber);
    if (serailNumberItem.key == '-' || (serailNumberItem.key != '-' && this.selectedSerialNumbers.filter(x => x.key == serailNumberItem.key).length == 0)) {
      this.selectedSerialNumbers.push(serailNumberItem);
    }
    if (serailNumberItem.key != '-') {
      this.serialNumbers = this.serialNumbers.filter(x => x.key != serailNumberItem.key);
    }
    this.selectedSerialNumber = null;
    this.txtSerialNumber = '';
    if (key) {
      this.localService.onFocusNextInput(this.elementIds.manual_ser_num, FocusInputType.TextBox);
    }
  }

  onRemove(id) {
    if (!this.serialNumbers || this.serialNumbers.length == 0) {
      this.onLoadSerialNumbers();
    }
    if (id != '-') {
      if (this.serialNumbers && !this.serialNumbers.find(x => x.key == id))
        this.serialNumbers.push(this.selectedSerialNumbers.find(x => x.key == id));
      this.selectedSerialNumbers = this.selectedSerialNumbers.filter(x => x.key != id);
    } else {
      let isDeleted = false;
      this.selectedSerialNumbers.forEach(x => {
        if (!isDeleted) {
          x.v3 = "TO DELETE";
          isDeleted = true;
        }
      });
      this.selectedSerialNumbers = this.selectedSerialNumbers.filter(x => x.v3 != "TO DELETE");
    }
  }

  onApplyDummy() {
    let item = this.serialNumbers.find(x => x.key == '-');
    let remainingQty = this.qty - this.selectedSerialNumbers.length;
    for (var i = 0; i < remainingQty; i++) {
      this.selectedSerialNumbers.push(item);
    }
  }

  onSerialEnter(e) {
    if (e.target.value && (e.target.value.toString().includes(' ') || e.target.value.toString().includes('\t'))) {
      e.target.value = e.target.value.replace(/ /gi, "").replace(/\t/gi, "");
      this.txtSerialNumber = this.txtSerialNumber.replace(/ /gi, "").replace(/\t/gi, "");
    }
  }
}
